import Vue from 'vue'
import Router from 'vue-router'

import Intro from '@/pages/Intro'

import Home from '@/pages/Home'

import Artists from '@/pages/Artists'
import Artist from '@/pages/Artist/Artist.vue'
import Gallery from '@/pages/Artist/Gallery.vue'

import Map from '@/pages/Map/Map.vue'

import Partners from '@/pages/Partners'
import Partner from '@/pages/Partner'
import Events from '@/pages/Events'
import About from '@/pages/About'
import Press from '@/pages/Press'
import FAQ from '@/pages/FAQ'
import ThankYou from '@/pages/ThankYou'
import PrivacyPolicy from '@/pages/PrivacyPolicy'
import Support from '@/pages/Support'
import ThemedTours from '@/pages/ThemedTours'
import Page from '@/pages/Page'

import ASTForm from '@/pages/Forms/AST.vue'
import BPForm from '@/pages/Forms/BP.vue'
import EventsForm from '@/pages/Forms/Event.vue'

Vue.use(Router);

let routes = [
  // INTRO
  {
    path: '/intro/',
    name: 'intro',
    component: Intro,
    meta: {
      page: 0,
    }
  },


  // HOME
  {
    path: '/',
    name: 'home',
    component: Home,
    beforeEnter(to, from, next) {
      window.location.replace('https://almostrealthings.com/austinstudiotour')
    },
    meta: {
      page: 1
    }
  },

  // ARTISTS
  {
    path: '/participants/',
    name: 'participants',
    component: Artists,
    meta: {
      page: 2
    },
    // beforeEnter(to, from, next) {
    //   window.location.replace('https://www.bigmedium.org/ast-23-on-the-tour')
    // },
  },
  {
    path: '/participants/:id',
    name: 'participant',
    component: Artist,
    meta: {
      page: 3,
    },
    // beforeEnter(to, from, next) {
    //   window.location.replace('https://www.bigmedium.org/ast-23-on-the-tour')
    // },
  },
  {
    path: '/participants/:id/gallery',
    name: 'gallery',
    component: Gallery,
    meta: {
      page: 4,
    },
    // beforeEnter(to, from, next) {
    //   window.location.replace('https://www.bigmedium.org/ast-23-on-the-tour')
    // },
  },

  // MAP
  {
    path: '/map/',
    name: 'map',
    component: Map,
    meta: {
      page: 2
    }
  },

  // PARTNERS
  {
    path: '/partners/',
    name: 'partners',
    component: Partners,
    meta: {
      page: 2
    }
  },
  {
    path: '/partners/:id',
    name: 'partner',
    component: Partner,
    meta: {
      page: 3,
    }
  },

  // EVENTS
  {
    path: '/events/',
    name: 'events',
    component: Events,
    meta: {
      page: 2
    }
  },

  // ThemedTours
  {
    path: '/themedtours/',
    name: 'themedtours',
    component: ThemedTours,
    meta: {
      page: 2
    }
  },

  // ABOUT
  {
    path: '/about/',
    name: 'about',
    component: About,
    meta: {
      page: 2,
    }
  },

  // PRIVACY POLICY
  {
    path: '/privacy-policy/',
    name: 'privacypolicy',
    component: PrivacyPolicy,
    meta: {
      page: 2,
    }
  },

  // PRESS
  {
    path: '/press/',
    name: 'press',
    component: Press,
    meta: {
      page: 2
    }
  },

  // FAQ
  {
    path: '/FAQ/',
    name: 'faq',
    component: FAQ,
    meta: {
      page: 2
    }
  },

  // THANK YOU
  {
    path: '/thankyou/',
    name: 'thankyou',
    component: ThankYou,
    meta: {
      page: 2
    }
  },

  // SUPPORT
  {
    path: '/support/',
    name: 'support',
    component: Support,
    meta: {
      page: 2
    }
  },

  // ANY PAGE
  {
    path: '*',
    name: 'page',
    component: Page,
    meta: {
      page: 2
    }
  },

  // FORMS
  {
    path: '/participate',
    name: 'ast-app',
    component: ASTForm,
    // beforeEnter(to, from, next) {
    //   window.location.replace('https://austinstudiotour.org/')
    // },
  },
  {
    path: '/bp-app',
    name: 'bp-app',
    component: BPForm,
    // beforeEnter(to, from, next) {
    //   window.location.replace('https://austinstudiotour.org/')
    // },
  },
  {
    path: '/events-app',
    name: 'events-app',
    component: EventsForm,
    // beforeEnter(to, from, next) {
    //   window.location.replace('https://austinstudiotour.org/')
    // },
  },
];

export default new Router({
  routes: routes,
})



// WEBPACK FOOTER //
// ./src/router.js